import * as React from "react";
import "../proposols/step1/proposol.css";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { set_info2 } from "../../Redux/action";
import { useDispatch, useSelector } from "react-redux";
import { AutoComplete, Col, Form,Input, Row,Select,Button,DatePicker } from "antd/lib";
import moment from "moment";
import Shownominee from "./ShowNominee";
//const axios = require("axios");
const Relation = [
  { label: "DAUGHTER" },
  { label: "DAUGHTER IN LAW" },
  { label: "GRAND CHILD" },
  { label: "HEAD" },
  { label: "WIFE" },
  { label: "MOTHER" },
  { label: "FATHER" },
  { label: "SON" },
  { label: "SPOUSE" },
  { label: "HUSBAND" },
  { label: "LONGTIME_PARTNER" },
  { label: "CHILD" },
  { label: "SISTER" },
  { label: "BROTHER" }
];
function Proposal2Health({showStep4,setShowStep4,Ref4}) {
  const NomineeDetail = useSelector((state) => state?.addressdetail?.info2);
  const store = useSelector((state) => state.addressdetail);
  const [form] = Form.useForm();
  const [formLayout] = useState('vertical');
  const { Option } = Select;
  const dispatch = useDispatch();

  const [dateString, setdateString] = useState('')
  const [loading, setLoading] = useState(false);

  const history = useHistory();

   const onDateChange = (date, dateString) => {
        // console.log(date);
        // console.log(dateString)
        setdateString(dateString)
      };
  const onFinish = (values) => {
    setLoading(true)
    // console.log(values)
    values.Nage= moment(values.Nage).format('YYYY-MM-DD')
    var data = {
      Nname: values.Nname,
      Nrelation: values.Nrelation,
      Nage: values.Nage
    }
    // console.log(data)
    dispatch(set_info2(data))
    
    setTimeout(()=>{
      setLoading(false)
      setShowStep4(true)
      Ref4.current?.scrollIntoView({ behavior: "smooth" });
      //history.push("/step3");
    },500)
  }
  const onFinishFailed = (values) => {
    console.log(values)
    form.scrollToField(values.errorFields[0].name);
  }
  
  const disabledDate = (current) => {
    const today = moment();
    const minDate = today.subtract(18, 'years'); 
  
    return current.isAfter(minDate, 'day'); 
  };
  const getDefaultPickerValue = () => {
    const today = moment();
    const minDate = today.subtract(18, 'years');
    return minDate;
  };
  return (
    <>
    {showStep4 ? <Shownominee/> :
    <div className="gridparent-skb" >
    <Form
        layout={formLayout}
        form={form}
        style={{paddingTop: "10px"}}
        requiredMark={false}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item 
                label="Nominee Name"
                name='Nname'
                rules={[{
                required: true, 
                message: 'please input Nominee Name'
              }]}
              initialValue={NomineeDetail?.Nname}
              >
              <Input
                style={{width: "100%"}}
                placeholder="Nominee Name" 
              />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item 
                label="Nominee Relationship"
                name='Nrelation'
                rules={[{
                required: true, 
                message: 'please input Nominee Relationship'
                }]}
                initialValue={NomineeDetail?.Nrelation}
                >
                 <AutoComplete
                    placeholder="Select Relationship"
                  >
                    {Relation.map((option) => (
                      <Option key={option.id} value={option.label}>
                        {option.label}
                      </Option>
                    ))}
                  </AutoComplete>
                </Form.Item>
              </Col>
            <Col span={8}>
                <Form.Item
                  label="Nominee Date of Birth"
                  name='Nage'
                  rules={[
                    {
                      required: true,
                      message: 'Please select DOB',
                    },
                  ]}
                  initialValue={NomineeDetail?.Nage ? moment(NomineeDetail?.Nage) : null}
                  >
                    <DatePicker
                      style={{width: "100%", padding: "8px"}}
                      disabledDate={disabledDate}
                      defaultPickerValue={getDefaultPickerValue()}
                      format="YYYY-MM-DD"
                      onChange={onDateChange}
                      placeholder="YYYY-MM-DD"
                    />
                  </Form.Item>
              </Col>
              </Row>
            <Row gutter={24}>
            <Col span={24}>
              <Form.Item style={{textAlign: "center"}}>
                {showStep4 ? null :
                <Button loading={loading}
                 type="primary" 
                 style={{background: "#293890",border: "#293890"}}
                 htmlType="submit">
                  Submit
                </Button> }
              </Form.Item>
            </Col>
            </Row>
        </Form>
    </div>
    }
    </>
  );
}

export { Proposal2Health };
